module.exports = __webpack_public_path__ + "static/media/focus.c8a32a38.png";